"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { AlertCircle, ArrowUpRight } from "@/components/icons";
import { SectionHeader } from "@/components/ui";
import { WEBSHARE_FAQ_URL, PRICING_VERIFIED_DATE } from "./pricing-data";

const MotionDiv = motion.div;

export default function WebshareMobileStatus() {
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = (delay = 0) => ({
    initial: prefersReducedMotion ? {} : { opacity: 0, y: 24 },
    whileInView: prefersReducedMotion ? {} : { opacity: 1, y: 0 },
    viewport: scrollRevealViewport,
    transition: { duration: 0.55, delay },
  });

  return (
    <section className="py-section border-border border-b" aria-labelledby="mobile-status-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <MotionDiv {...fadeUp(0)} className="mb-10 max-w-2xl">
          <SectionHeader
            eyebrow="What's Different"
            id="mobile-status-heading"
            heading="Does Webshare offer mobile proxies?"
            body="Short answer: no. Here's exactly what Webshare's own pages and FAQ say."
          />
        </MotionDiv>

        <MotionDiv
          {...fadeUp(0.08)}
          className="border-border bg-card flex gap-4 rounded-xl border p-6 sm:p-7"
        >
          <AlertCircle
            size={20}
            className="mt-0.5 shrink-0"
            style={{ color: "var(--yellow-400)" }}
            aria-hidden="true"
          />
          <div>
            <p className="text-foreground text-sm leading-relaxed sm:text-base">
              Webshare&rsquo;s public product lineup is rotating residential, static residential
              (ISP), and datacenter proxies. Its own FAQ, when comparing itself to providers that do
              sell mobile proxies, states plainly that mobile proxies aren&rsquo;t currently part of
              its lineup. There is no mobile category, mobile pricing, or mobile targeting to
              compare against.
            </p>
            <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
              If your workload specifically needs a premium cellular mobile IP — not a static
              ISP-registered address hosted on datacenter infrastructure — Webshare&rsquo;s current
              products won&rsquo;t cover it. This page reflects what&rsquo;s publicly listed as of{" "}
              {PRICING_VERIFIED_DATE}.
            </p>
            <a
              href={WEBSHARE_FAQ_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-muted-foreground hover:text-foreground mt-4 inline-flex items-center gap-1.5 text-sm font-medium transition-colors"
            >
              See Webshare&rsquo;s FAQ
              <ArrowUpRight size={14} aria-hidden="true" />
            </a>
          </div>
        </MotionDiv>
      </div>
    </section>
  );
}
